import React from 'react';
import { useTranslation } from 'react-i18next';

const T_COLOR = '#de9b35';
const CT_COLOR = '#5d79ae';

interface ReplaySwingBarProps {
    tPct: number; // the T side's chance of winning the round right now (0-100)
    decided: boolean; // past the point where the round could still turn: kills carry no swing
}

// Live round odds under the score header (swing overlay): T on the left and CT on the right,
// like the header. Steps at each kill and the plant; the width eases so the shift is visible.
const ReplaySwingBar: React.FC<ReplaySwingBarProps> = ({ tPct, decided }) => {
    const { t } = useTranslation('pages');
    const tp = Math.min(100, Math.max(0, tPct));
    const label = (v: number) => `${v.toFixed(1)}%`;
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '5px 16px',
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            borderBottom: '1px solid var(--border-primary, #333)',
            flexShrink: 0,
            fontSize: '0.75rem',
            fontWeight: 700,
            fontVariantNumeric: 'tabular-nums',
        }}>
            <span style={{ color: T_COLOR, minWidth: 44 }}>{label(tp)}</span>
            <div style={{
                position: 'relative',
                flex: 1,
                height: 8,
                borderRadius: 4,
                overflow: 'hidden',
                backgroundColor: CT_COLOR,
                opacity: decided ? 0.55 : 1,
            }}
                role="meter" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(tp)}
                aria-label={t('match2.swing.replayOdds')}>
                <div style={{
                    position: 'absolute', left: 0, top: 0, bottom: 0,
                    width: `${tp}%`,
                    backgroundColor: T_COLOR,
                    transition: 'width 0.35s ease',
                }} />
                {/* the 50% mark, so "who is ahead" reads without the numbers */}
                <div style={{ position: 'absolute', left: '50%', top: 0, bottom: 0, width: 1, background: 'rgba(0,0,0,0.45)' }} />
            </div>
            <span style={{ color: CT_COLOR, minWidth: 44, textAlign: 'right' }}>{label(100 - tp)}</span>
            {decided && (
                <span style={{
                    fontSize: '0.6rem', fontWeight: 800, letterSpacing: '0.05em', textTransform: 'uppercase',
                    color: 'rgba(255,255,255,0.6)', border: '1px solid rgba(255,255,255,0.25)',
                    borderRadius: 3, padding: '0 4px', lineHeight: '14px',
                }}>{t('match2.swing.decidedMarker')}</span>
            )}
        </div>
    );
};

export default ReplaySwingBar;
